/**
 * デザインサイト メンテナンス予約：ブラウザの現在時刻による表示切り替え
 *
 * ページがキャッシュされると、サーバー側（Liquid）の判定結果が古いまま配信されることがある。
 * そのため snippets/custom-maintenance-button.liquid は通常版・メンテナンス版の両方を出力し、
 * 予約の開始・終了（epoch秒）を data属性で渡す。ここで現在時刻と比べて hidden を切り替える。
 *
 *   [data-custom-maint-switch]  data-maint-manual="1|0" data-maint-start data-maint-end
 *     └ [data-maint-variant="normal"]  通常時に表示
 *     └ [data-maint-variant="maint"]   メンテナンス中に表示
 *
 * 時刻はブラウザの時計を使う（端末の時計がずれている場合は、その分ずれる）。
 */
(function () {
  'use strict';

  // 複数回読み込まれても、再判定するだけで二重登録しない
  if (window.__customMaintSchedule) {
    window.__customMaintSchedule.apply();
    return;
  }

  var SWITCH = '[data-custom-maint-switch]';
  var MAX_TIMEOUT = 2147483647; // setTimeout の上限（約24.8日）
  var timer = null;

  function toNumber(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n;
  }

  function isMaintenance(el) {
    if (el.getAttribute('data-maint-manual') === '1') return true;
    var start = toNumber(el.getAttribute('data-maint-start'));
    var end = toNumber(el.getAttribute('data-maint-end'));
    if (!(start > 0 && end > start)) return false;
    var now = Date.now() / 1000;
    return now >= start && now < end;
  }

  function apply() {
    var switches = document.querySelectorAll(SWITCH);
    var nextBoundary = 0;
    var now = Date.now() / 1000;

    Array.prototype.forEach.call(switches, function (el) {
      var maint = isMaintenance(el);
      Array.prototype.forEach.call(el.querySelectorAll('[data-maint-variant]'), function (variant) {
        var isNormal = variant.getAttribute('data-maint-variant') === 'normal';
        variant.hidden = isNormal ? maint : !maint;
      });

      [toNumber(el.getAttribute('data-maint-start')), toNumber(el.getAttribute('data-maint-end'))].forEach(function (t) {
        if (t > now && (nextBoundary === 0 || t < nextBoundary)) nextBoundary = t;
      });
    });

    // 次の境界時刻（開始／終了）ちょうどに再判定する
    if (timer) clearTimeout(timer);
    if (nextBoundary > 0) {
      var wait = Math.min(Math.max((nextBoundary - now) * 1000 + 200, 0), MAX_TIMEOUT);
      timer = setTimeout(apply, wait);
    }
  }

  // クリックの瞬間にも時刻を判定する。表示の切り替えが間に合っていなくても、
  // メンテナンス中は遷移させない（タブがバックグラウンドで止まっていた場合の保険）。
  function guardClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var normal = target.closest('[data-maint-variant="normal"]');
    if (!normal) return;
    var sw = normal.closest(SWITCH);
    if (sw && isMaintenance(sw)) {
      event.preventDefault();
      event.stopPropagation();
      apply();
    }
  }

  window.__customMaintSchedule = { apply: apply };

  document.addEventListener('click', guardClick, true);
  document.addEventListener('auxclick', guardClick, true);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) apply();
  });
  window.addEventListener('pageshow', apply); // 戻る／進む（bfcache）からの復帰
  window.addEventListener('focus', apply);
  setInterval(apply, 15000); // バックグラウンドでタイマーが間引かれた場合の保険

  // テーマエディタでセクションが再描画された場合にも追従する
  document.addEventListener('shopify:section:load', apply);

  apply();
})();
